module.exports = __webpack_public_path__ + "img/icon_1.644a5c2e.svg";